module.exports = __webpack_public_path__ + "static/media/ag.8bd07b26.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ag.svg
// module id = 852
// module chunks = 0